import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-58db71d0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "faq-sections" }
const _hoisted_2 = { class: "row g-5" }
const _hoisted_3 = { class: "col-12 col-md-4 col-lg-3" }
const _hoisted_4 = { class: "reset-ul list-sections d-none d-md-block" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, ">", -1))
const _hoisted_6 = { class: "d-block d-md-none" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = { class: "col-12 col-md-8 col-lg-9" }
const _hoisted_9 = { class: "title" }
const _hoisted_10 = {
  key: 1,
  class: "reset-ul list-articles"
}

import { inject, ComputedRef, Ref } from 'vue';
  import { useRouter } from 'vue-router';
  import { faqSectionsStore, FaqSectionArticlesStore } from '@/stores';
  import { IFaqSection } from '@/types/faq-section';
  import CardArticle from './components/card-article.vue';

  
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  const faqSectionArticlesStore = inject('faqSectionArticlesStore') as Ref<FaqSectionArticlesStore>;
  const currentSection = inject('currentSection') as ComputedRef<IFaqSection>;

  function handlePageChange(page: number) {
    faqSectionArticlesStore.value.fetchData({ page });
  }

  const router = useRouter();
  function handleNavToSection(id: any) {
    router.replace({ params: { id } });
  }


return (_ctx: any,_cache: any) => {
  const _component_AppBreadcurmb = _resolveComponent("AppBreadcurmb")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_b_form_select = _resolveComponent("b-form-select")!
  const _component_AppEmptyView = _resolveComponent("AppEmptyView")!
  const _component_AppPagination = _resolveComponent("AppPagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_AppBreadcurmb, {
      class: "breadcurmb",
      routes: [
        {
          name: 'Home', to: {name: 'home'}
        },
        {
          name: _unref(currentSection).title
        }
      ]
    }, null, 8, ["routes"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("ul", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(faqSectionsStore).data, (item) => {
            return (_openBlock(), _createElementBlock("li", {
              key: item.id
            }, [
              _createVNode(_component_router_link, {
                replace: "",
                to: { params: { id: item.id } }
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.title) + " ", 1),
                  _hoisted_5
                ]),
                _: 2
              }, 1032, ["to"])
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_b_form_select, {
            "model-value": _unref(currentSection).id,
            options: _unref(faqSectionsStore).data,
            "value-field": "id",
            "text-field": "title",
            onChange: handleNavToSection
          }, null, 8, ["model-value", "options"]),
          _hoisted_7
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("h3", _hoisted_9, _toDisplayString(_unref(currentSection).title), 1),
        (_unref(faqSectionArticlesStore).isEmpty)
          ? (_openBlock(), _createBlock(_component_AppEmptyView, { key: 0 }))
          : (_openBlock(), _createElementBlock("ul", _hoisted_10, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(faqSectionArticlesStore).data, (item) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: item.id
                }, [
                  _createVNode(CardArticle, { article: item }, null, 8, ["article"])
                ]))
              }), 128))
            ])),
        (_unref(faqSectionArticlesStore).meta.total_pages > 1)
          ? (_openBlock(), _createBlock(_component_AppPagination, {
              key: 2,
              total: _unref(faqSectionArticlesStore).meta.total,
              "per-page": _unref(faqSectionArticlesStore).meta.per_page,
              page: _unref(faqSectionArticlesStore).meta.page,
              onChange: handlePageChange
            }, null, 8, ["total", "per-page", "page"]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})